import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { spinnerFeatureKey, spinnerReducer } from './state/spinner.reducer';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(spinnerFeatureKey, spinnerReducer), 
  ]
})
export class KioskSpinnerModule { }
